export enum AttendanceStatusEnum {
  ATTENDED = 'ATTENDED',
  EXCUSED = 'EXCUSED',
  NO_SHOW = 'NO_SHOW'
}
